import Header from 'cost_centers/components/list/CostCentersListHeader';
import Filters from 'cost_centers/components/list/CostCentersListFilters';
import Table from 'cost_centers/components/list/CostCentersListTable';
import Row from 'cost_centers/components/list/CostCentersListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/list/index.js